(function () {
  'use strict';

  angular.module('dstreamApp.views', [
      'dstreamApp.views.detailed-transactions',
      'dstreamApp.views.invoice-register',
      'dstreamApp.views.archive-register',
      'dstreamApp.views.archive-details',
  ]);
})();